module.exports = __webpack_public_path__ + "media/images/responsive_bus-e8015a5896991a445f1efa6b708f603a.png";